import React, { useState, useEffect } from 'react';
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Mantra from '../components/Mantra';
import DropItems from '../components/dropItems';
import Footer from '../components/Footer';

import '../styles/App.css';
import '../styles/CTA.css';
import HeroImage from '../assets/images/drops/Sam_Begin_1.jpg';
import MantraImage from '../assets/images/Mantra_1.png';

function Drops() {
  function EmailForm() {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!isValid) {
        setError("Please enter a valid email address.");
        setSuccess("");
        return;
      }
    
      setIsSubmitting(true);
      setError("");
    
      try {
        const docRef = await addDoc(collection(db, "dropsSignups"), {
          email: email,
          timestamp: new Date(),
          subscribe: "active"
        });
        console.log("✅ Email submitted to Firebase with ID:", docRef.id);
        setSuccess("Thanks! You're on the list.");
        setEmail("");
        setSubmitted(true);
      } catch (err) {
        console.error("❌ Firebase submission error:", err);
        setError("Something went wrong. Please try again.");
        setIsSubmitting(false);
      }
    };

    useEffect(() => {
      if (submitted) {
        const timer = setTimeout(() => {
          setSubmitted(false);
          setSuccess("");
          setIsSubmitting(false);
        }, 3000);
        return () => clearTimeout(timer);
      }
    }, [submitted]);

    return (
      <form className="cta-form" onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`cta-input email ${error ? "error" : ""}`}
          placeholder="you@email.com"
          required
        />
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        {!submitted && (
          <button
            type="submit"
            className="c-ripple primary-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Submit"}
          </button>
        )}
      </form>
    );
  }

  return (
    <>
      <SEO
        title="Apparel Drops"
        description="Limited runs of Begin Strength gear: shirts, hats, and essentials. Sign up for alerts and grab your gear before it's gone."
        image="/og-images/drops.jpg"
        path="/drops"
      />
      <Header />
      <Hero
        backgroundImage={HeroImage}
        headerText={
          <>
            Apparel<br /><span style={{ color: "red" }}>Drops</span>
          </>
        }
        paragraphText={
          <>
            <p>
              Every now and then, we drop limited runs of Begin Strength gear: shirts, hats, and other essentials.
            </p>
            <p>
              If you want first dibs, sign up for alerts and grab your gear before it’s gone.
            </p><br/>
            <EmailForm />
          </>
        }
      />

      <DropItems />
      <Mantra
        backgroundImage={MantraImage}
        mantraText="Seven Days Off makes One Weak"
      />
      <Footer />
    </>
  );
}

export default Drops;